export const marketplaceQueryKeys = {
  marketplace: ['marketplace'],
  allConfigs: () => [...marketplaceQueryKeys.marketplace, 'all-configs'],
  projectConfig: (slug: string) => [
    ...marketplaceQueryKeys.marketplace,
    'project-config',
    slug,
  ],
};

export const marketplaceMutationKeys = {
  marketplace: ['marketplace'],
  marketplaceScale: (slug: string) => [
    ...marketplaceMutationKeys.marketplace,
    'scale',
    slug,
  ],
};
